import React, { lazy, Suspense, useEffect } from "react";
import { paths } from "../config/constants";
import { Route, Routes, useLocation } from "react-router-dom";
import Error from "../pages/Error";
import AppLayout from "../component/layout/AppLayout";
import { PageLoading } from "../component/includes/PageLoading";
import DriverLayout from "../component/layout/DriverLayout";
import DriverCarrierLayout from "../pages/DriverCarrier/DriverCarrierLayout";
import Bussinesslayout from "../component/layout/Bussinesslayout";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MyStaff from "../pages/BussinessAgent/myStaff";
import CompanyLayout from "../pages/BussinessAgent/companyLayout";
import Dashboard from "../pages/BussinessAgent/dashboard";
import EditBussinessBooking from "../pages/BussinessAgent/editBussinessBooking";
import ReportsPage from "../pages/BussinessAgent/ReportsPage";
import ProtectedRoute from "./ProtectedRoute";
import { ROLES } from "../config/roles";
// import { resetContact } from "../redux/reducers/contactReducer";
// import { resetHomeRe } from "../redux/reducers/homeReducer";
// import { reset } from "../redux/reducers/login";

//Common
const PrivacyPolicy = lazy(() => import("../pages/PrivacyPolicy"));
const Qans = lazy(() => import("../pages/Qans"));
const SocialLogin = lazy(() => import("../pages/SocialLogin"));
const ContactUs = lazy(() => import("../pages/ContactUs"));
const BussinessAccount = lazy(() => import("../pages/BussinessAccount"));
const BookingTermsAndCond = lazy(() => import("../pages/BookingTermsAndCond"));
const CancellationPolicy = lazy(() => import("../pages/CancellationPolicy"));
const AboutUs = lazy(() => import("../pages/AboutUs"));
const TermsAndCondition = lazy(() => import("../pages/TermsAndCondition"));
const Done = lazy(() => import("../pages/Done"));
const Summary = lazy(() => import("../pages/Summary"));
const ContactInfo = lazy(() => import("../pages/ContactInfo"));
const VehicleOption = lazy(() => import("../pages/VehicleOption"));
const EditProfile = lazy(() => import("../pages/EditProfile"));
const MyRide = lazy(() => import("../pages/MyRide"));
const Home = lazy(() => import("../pages/Home"));

//Bussiness Agent
const BusinesHome = lazy(() => import("../pages/BussinessAgent/Home"));
const BusinesVehicleoption = lazy(() =>
  import("../pages/BussinessAgent/VehivleOption")
);
const BusinesContact = lazy(() => import("../pages/BussinessAgent/Contact"));
const BusinesSummary = lazy(() => import("../pages/BussinessAgent/Summery"));
const BusinesDone = lazy(() => import("../pages/BussinessAgent/Done"));
const BusinessRides = lazy(() =>
  import("../pages/BussinessAgent/BusinessRides")
);
const BusinessRegisterStaff = lazy(() =>
  import("../pages/BussinessAgent/StaffRegister")
);
const EditStaff = lazy(() =>
  import("../pages/BussinessAgent/EditStaff")
);
const BussinessBooking = lazy(() =>
  import("../pages/BussinessAgent/bussinessBooking")
);
//driver
const DriverTermsConditons = lazy(() =>
  import("../pages/driver/DriverTermsAndCondition")
);
const RideHistory = lazy(() => import("../pages/driver/RideHistory"));
const OpenBooking = lazy(() => import("../pages/driver/OpenBooking"));
const DriverVehical = lazy(() => import("../pages/driver/DriveAndVehicle"));
const RideDetails = lazy(() => import("../pages/driver/RideDetails"));
const UpcomingRides = lazy(() => import("../pages/driver/UpcomingRides"));
const DriverCarrierDashboard = lazy(() => import("../pages/DriverCarrier/DriverCarrierDashboard"));
const DriverCarrierOpenBooking = lazy(() => import("../pages/DriverCarrier/DriverCarrierOpenBooking"));
const DriverCarrierMyBookings = lazy(() => import("../pages/DriverCarrier/DriverCarrierMyBookings"));
const DriverCarrierAssignDriverVehicle = lazy(() => import("../pages/DriverCarrier/DriverCarrierAssignDriverVehicle"));
const DriverCarrierUpcomingBookings = lazy(() => import("../pages/DriverCarrier/DriverCarrierUpcomingBookings"));
const DriverCarrierEditProfile = lazy(() => import("../pages/DriverCarrier/DriverCarrierEditProfile"));
const DriverCarrierCreateBooking = lazy(() => import("../pages/DriverCarrier/DriverCarrierCreateBooking"));
const DriverCarrierEditBooking = lazy(() => import("../pages/DriverCarrier/DriverCarrierEditBooking"));
const AddEditDriver = lazy(() =>  import("../pages/DriverCarrier/AddEditDriver"));
const DriversList = lazy(() => import("../pages/DriverCarrier/DriversList"));
const DriverCarrierVehicles = lazy(() => import("../pages/DriverCarrier/DriverCarrierVehicles"));
const MyBookingsReportPage = lazy(()=>import("../pages/DriverCarrier/MyBookingsReportPage"))
const CarrierRideHistory = lazy(()=>import("../pages/DriverCarrier/CarrierRideHistory"))
const CarrierInvoiceHistory = lazy(()=>import("../pages/DriverCarrier/CarrierInvoiceHistory"))
const CarrierTermsAndConditions = lazy(()=>import("../pages/DriverCarrier/CarrierTermsAndConditions"))
const CarrierCancellationPolicy = lazy(()=>import("../pages/DriverCarrier/CarrierCancellationPolicy"))
const InvoiceHistory = lazy(() => import("../pages/driver/InvoiceHistory"));
const TaxValues = lazy(() => import("../pages/driver/TaxValues"));

//auth
const ForgetPassword = lazy(() => import("../pages/auth/ForgetPassword"));
const ChangePassword = lazy(() => import("../pages/auth/ChangePassword"));
const LogIn = lazy(() => import("../pages/auth/Login"));
const DriverRegistration = lazy(() =>
  import("../pages/auth/DriverRegistration")
);
const AgentRegistration = lazy(() =>
  import("../pages/auth/AgentRegistration")
);
const PartnerRegister = lazy(() => import("../pages/auth/PartnerRegister"));
const DriverCarrierRegistration = lazy(() =>
  import("../pages/auth/DriverCarrierRegistration")
);

function RouteApp() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // const dispatch = useDispatch();
  // const navigate =  useNavigate();
  // const reduxdata = useSelector((state) => state);
  // let token = reduxdata?.login?.token;

// useEffect(() => {
//   const storedTokenTimestamp = localStorage.getItem('tokenTimestamp');
//   if (token) {
//     const currentTime = Date.now();
//     const storedTimestamp = parseInt(storedTokenTimestamp, 10);
//     const tokenExpirationTime =30000; 
//     if (currentTime - storedTimestamp >= tokenExpirationTime) {
//       handleExpire();
//     }
//   }
// }, [token]);

//   const handleExpire =() => {
         
//       toast.error("Session Expired!", {autoClose:2500});
//       dispatch(resetContact());
//       dispatch(resetHomeRe());
//       dispatch(reset());
//       sessionStorage.clear();
//       // localStorage.clear();
//       navigate(paths.accounts.login);
//       toast.success("Logout Successfully! ", {autoClose:2500});

//   }
  return (
    <>
      <Routes>
        {/* auth page */}
        <Route path={paths.accounts.home} element={<AppLayout />}>
          <Route
            path={paths.accounts.forgetPassword+'/:token'}
            element={
              <Suspense fallback={<PageLoading />}>
                <ForgetPassword />
              </Suspense>
            }
          />
          <Route
            path={paths.accounts.changePassword}
            element={
              <Suspense fallback={<PageLoading />}>
                <ChangePassword />
              </Suspense>
            }
          />
          <Route
            path={paths.accounts.driverRegister}
            element={
              <Suspense fallback={<PageLoading />}>
                <DriverRegistration />
              </Suspense>
            }
          />
          <Route
            path={paths.accounts.agentRegister}
            element={
              <Suspense fallback={<PageLoading />}>
                <AgentRegistration />
              </Suspense>
            }
          />
          <Route
            path={paths.accounts.partnerRegister}
            element={
              <Suspense fallback={<PageLoading />}>
                <PartnerRegister />
              </Suspense>
            }
          />
          <Route
            path={paths.accounts.driverCarrierRegister}
            element={
              <Suspense fallback={<PageLoading />}>
                <DriverCarrierRegistration />
              </Suspense>
            }
          />
          <Route
            path={paths.accounts.login}
            element={
              <Suspense fallback={<PageLoading />}>
                <LogIn />
              </Suspense>
            }
          />
          <Route
            path={paths.accounts.socialLogin}
            element={
              <Suspense fallback={<PageLoading />}>
                <SocialLogin />
              </Suspense>
            }
          />
        </Route>

        {/* drivers page */}
       <Route element={<ProtectedRoute allowedRoles={["Driver"]} />}>
        <Route path={paths.driver.home} element={<DriverLayout />}>
          <Route
            path={paths.driver.driveVehicle}
            element={
              <Suspense fallback={<PageLoading />}>
                <DriverVehical />
              </Suspense>
            }
          />
          <Route
            path={paths.driver.taxValues}
            element={
              <Suspense fallback={<PageLoading />}>
                <TaxValues />
              </Suspense>
            }
          />
          <Route
            path={paths.driver.rideDetails}
            element={
              <Suspense fallback={<PageLoading />}>
                <RideDetails />
              </Suspense>
            }
          />
          <Route
            path={paths.driver.upcomingRides}
            element={
              <Suspense fallback={<PageLoading />}>
                <UpcomingRides />
              </Suspense>
            }
          />
          <Route
            path={paths.driver.invoiceHistory}
            element={
              <Suspense fallback={<PageLoading />}>
                <InvoiceHistory />
              </Suspense>
            }
          />
           <Route
            path={paths.driver.openBooking}
            element={
              <Suspense fallback={<PageLoading />}>
                <OpenBooking />
              </Suspense>
            }
          />
           <Route
            path={paths.driver.rideHistory}
            element={
              <Suspense fallback={<PageLoading />}>
                <RideHistory />
              </Suspense>
            }
          />
          <Route
            path={paths.driver.driverEditProfile}
            element={
              <Suspense fallback={<PageLoading />}>
                <EditProfile />
              </Suspense>
            }
          />
          <Route
            path={paths.driver.driverTermsCondition}
            element={
              <Suspense fallback={<PageLoading />}>
                <DriverTermsConditons />
              </Suspense>
            }
          />
        </Route>
</Route>
        
        
        {/* businessAgent */}
<Route element={<ProtectedRoute allowedRoles={["Agent"]} />}>
        <Route path={paths.businessAgent.home} element={<CompanyLayout />}>
          <Route
              path={paths.businessAgent.dashboard}
              element={
                <Suspense fallback={<PageLoading />}>
                  <Dashboard />
                </Suspense>
              }
            />
            <Route
            path={paths.businessAgent.editProfile}
            element={
              <Suspense fallback={<PageLoading />}>
                <EditProfile />
              </Suspense>
            }
          />
           <Route
            path={paths.businessAgent.BussinessBooking}
            element={
              <Suspense fallback={<PageLoading />}>
                <BussinessBooking />
              </Suspense>
            }
          />
          <Route
            path={paths.businessAgent.ReportsPage}
            element={
              <Suspense fallback={<PageLoading />}>
                <ReportsPage/>
              </Suspense>
            }
          />
          <Route
            path={paths.businessAgent.changePassword}
            element={
              <Suspense fallback={<PageLoading />}>
                <ChangePassword />
              </Suspense>
            }
          />
          <Route
            path={paths.businessAgent.editBussinessBooking}
            element={
              <Suspense fallback={<PageLoading />}>
                <EditBussinessBooking />
              </Suspense>
            }
          />
                    <Route
            path={paths.businessAgent.termsAndCondition}
            element={
              <Suspense fallback={<PageLoading />}>
                <TermsAndCondition />
              </Suspense>
            }
          />

        </Route>
        </Route>
        
        {/* Company */}
        <Route element={<ProtectedRoute allowedRoles={["Company"]} />}>
        <Route path={paths.company.home} element={<CompanyLayout />}>
            <Route
              path={paths.company.dashboard}
              element={
                <Suspense fallback={<PageLoading />}>
                  <Dashboard />
                </Suspense>
              }
            />
             <Route
            path={paths.company.myStaff}
            element={
              <Suspense fallback={<PageLoading />}>
                <MyStaff />
              </Suspense>
            }
          />
          <Route
            path={paths.company.ReportsPage}
            element={
              <Suspense fallback={<PageLoading />}>
                <ReportsPage/>
              </Suspense>
            }
          />
          <Route
            path={paths.company.editBussinessBooking}
            element={
              <Suspense fallback={<PageLoading />}>
                <EditBussinessBooking />
              </Suspense>
            }
          />
          <Route
            path={paths.company.editProfile}
            element={
              <Suspense fallback={<PageLoading />}>
                <EditProfile />
              </Suspense>
            }
          />
           <Route
            path={paths.company.companyRegisterStaff}
            element={
              <Suspense fallback={<PageLoading />}>
                <BusinessRegisterStaff />
              </Suspense>
            }
          /> 
          <Route
            path={paths.company.EditStaff}
            element={
              <Suspense fallback={<PageLoading />}>
                <EditStaff />
              </Suspense>
            }
          />
          <Route
            path={paths.company.BussinessBooking}
            element={
              <Suspense fallback={<PageLoading />}>
                <BussinessBooking />
              </Suspense>
            }
          />
          <Route
            path={paths.company.changePassword}
            element={
              <Suspense fallback={<PageLoading />}>
                <ChangePassword />
              </Suspense>
            }
          />

                    <Route
            path={paths.company.termsAndCondition}
            element={
              <Suspense fallback={<PageLoading />}>
                <TermsAndCondition />
              </Suspense>
            }
          />
            
           {/* <Route
              path={paths.admin.changePassword}
              element={
                <Suspense fallback={<PageLoading />}>
                  <ChangePassword />
                </Suspense>
              }
            /> */}
          </Route>
</Route>
        
 <Route element={<ProtectedRoute allowedRoles={["Employee"]} />}>
 <Route path={paths.home} element={<AppLayout />}>
          <Route
            path={paths.employeeBooking}
            element={
              <Suspense fallback={<PageLoading />}>
                <BussinessBooking />
              </Suspense>
            }
          />
          <Route
            path={paths.employeeRideDetails}
            element={
              <Suspense fallback={<PageLoading />}>
                <BusinessRides />
              </Suspense>
            }
          />
          </Route>
</Route>


{/* driver carrier page */}
<Route element={<ProtectedRoute allowedRoles={["Carrier"]} />}>
        <Route path={paths.driverCarrier.home} element={<DriverCarrierLayout />}>
                   <Route
            path={paths.driverCarrier.dashboard}
            element={
              <Suspense fallback={<PageLoading />}>
                <DriverCarrierDashboard />
              </Suspense>
            }
          />
             <Route
            path={paths.driverCarrier.openBooking}
            element={
              <Suspense fallback={<PageLoading />}>
                <DriverCarrierOpenBooking />
              </Suspense>
            }
          />
                    <Route
            path={paths.driverCarrier.myBookings}
            element={
              <Suspense fallback={<PageLoading />}>
                <DriverCarrierMyBookings />
              </Suspense>
            }
          />
           <Route
            path={paths.driverCarrier.assignDriverVehicle}
            element={
              <Suspense fallback={<PageLoading />}>
                <DriverCarrierAssignDriverVehicle />
              </Suspense>
            }
          />
                    <Route
            path={paths.driverCarrier.upcomingBookings}
            element={
              <Suspense fallback={<PageLoading />}>
                <DriverCarrierUpcomingBookings />
              </Suspense>
            }
          />
                    <Route
            path={paths.driverCarrier.createBooking}
            element={
              <Suspense fallback={<PageLoading />}>
                <DriverCarrierCreateBooking />
              </Suspense>
            }
          />
         <Route
            path={paths.driverCarrier.editProfile}
            element={
              <Suspense fallback={<PageLoading />}>
                <DriverCarrierEditProfile />
              </Suspense>
            }
          />
          <Route
            path={paths.driverCarrier.editBooking}
            element={
              <Suspense fallback={<PageLoading />}>
                <DriverCarrierEditBooking />
              </Suspense>
            }
          />
           <Route
                    path={paths.driverCarrier.driverForm} 
                    element={
                        <Suspense fallback={<PageLoading />}>
                            <AddEditDriver />
                        </Suspense>
                    }
                />
          <Route
            path={paths.driverCarrier.driverList}
            element={
              <Suspense fallback={<PageLoading />}>
                <DriversList />
              </Suspense>
            }
          /> 
           <Route
            path={paths.driverCarrier.vehicles}
            element={
              <Suspense fallback={<PageLoading />}>
                <DriverCarrierVehicles />
              </Suspense>
            }
          />
          <Route
            path={paths.driverCarrier.MyBookingsReport}
            element={
              <Suspense fallback={<PageLoading />}>
                <MyBookingsReportPage />
              </Suspense>
            }
          />
          <Route
            path={paths.driverCarrier.carrierRideHistory}
            element={
              <Suspense fallback={<PageLoading />}>
                <CarrierRideHistory />
              </Suspense>
            }
          />
          <Route
            path={paths.driverCarrier.carrierInvoiceHistory}
            element={
              <Suspense fallback={<PageLoading />}>
                <CarrierInvoiceHistory />
              </Suspense>
            }
          />
          <Route
            path={paths.driverCarrier.carrierTermsAndConditions}
            element={
              <Suspense fallback={<PageLoading />}>
                <CarrierTermsAndConditions />
              </Suspense>
            }
          />
                   <Route
            path={paths.driverCarrier.carrierCancellationPolicy}
            element={
              <Suspense fallback={<PageLoading />}>
                <CarrierCancellationPolicy />
              </Suspense>
            }
          />

        </Route>
        </Route>


        {/* common pages */}
        <Route path={paths.home} element={<AppLayout />}>
          <Route
            index
            element={
              <Suspense fallback={<PageLoading />}>
                <Home />
              </Suspense>
            }
          />
          <Route
            path={paths.vehicle}
            element={
              <Suspense fallback={<PageLoading />}>
                <VehicleOption />
              </Suspense>
            }
          />
         
          <Route
            path={paths.contact}
            element={
              <Suspense fallback={<PageLoading />}>
                <ContactInfo />
              </Suspense>
            }
          />
          <Route
            path={paths.summary}
            element={
              <Suspense fallback={<PageLoading />}>
                <Summary />
              </Suspense>
            }
          />
          <Route
            path={paths.done}
            element={
              <Suspense fallback={<PageLoading />}>
                <Done />
              </Suspense>
            }
          />
                    <Route
            path={paths.agentTaxValues}
            element={
              <Suspense fallback={<PageLoading />}>
                <TaxValues />
              </Suspense>
            }
          />
          

                    <Route
            path={paths.agentProfile}
            element={
              <Suspense fallback={<PageLoading />}>
                <EditProfile />
              </Suspense>
            }
          />
          <Route
            path={paths.aboutUs}
            element={
              <Suspense fallback={<PageLoading />}>
                <AboutUs />
              </Suspense>
            }
          />
          <Route
            path={paths.bookingTermsAndCond}
            element={
              <Suspense fallback={<PageLoading />}>
                <BookingTermsAndCond />
              </Suspense>
            }
          />
           <Route
            path={paths.cancellationPolicy}
            element={
              <Suspense fallback={<PageLoading />}>
                <CancellationPolicy />
              </Suspense>
            }
          />
          <Route
            path={paths.bussinessAccount}
            element={
              <Suspense fallback={<PageLoading />}>
                <BussinessAccount />
              </Suspense>
            }
          />
          <Route
            path={paths.contactUs}
            element={
              <Suspense fallback={<PageLoading />}>
                <ContactUs />
              </Suspense>
            }
          />
          <Route element={<ProtectedRoute allowedRoles={["User"]} />}>
          <Route
            path={paths.editProfile}
            element={
              <Suspense fallback={<PageLoading />}>
                <EditProfile />
              </Suspense>
            }
          />

          <Route
            path={paths.myRide}
            element={
              <Suspense fallback={<PageLoading />}>
                <MyRide />
              </Suspense>
            }
          />
          </Route>
           <Route
            path={paths.privacyPolicy}
            element={
              <Suspense fallback={<PageLoading />}>
                <PrivacyPolicy />
              </Suspense>
            }
          />
            <Route
            path={paths.qans}
            element={
              <Suspense fallback={<PageLoading />}>
                <Qans />
              </Suspense>
            }
          />
              
        </Route>

        <Route
          path={"*"}
          element={
            <Suspense fallback={<PageLoading />}>
              <Error />
            </Suspense>
          }
        />
      </Routes>
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default RouteApp;
